import { ComboboxItem, Select, SelectProps } from '@mantine/core';
import { useGetCustomers } from 'api-hooks/customer';
import { NavigationRoutes } from 'common/constants';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
interface CustomerSelectProps extends SelectProps {}

export default function CustomerSelect(props: CustomerSelectProps) {
  const { t } = useTranslation();
  const {
    required,
    label = t('common:customer'),
    placeholder = t('common:select_customer'),
    ...rest
  } = props;
  const { pathname } = useRouter();

  const _required = React.useMemo(() => {
    switch (pathname) {
      case NavigationRoutes.CustomerMutationReport:
        return true;
      default:
        return required;
    }
  }, [pathname, required]);

  const query = useGetCustomers({
    params: {
      limit: -1,
    },
  });

  const data: ComboboxItem[] = (query.data?.data || []).map((v) => ({
    value: v.id,
    label: v.name,
  }));
  return (
    <Select
      {...rest}
      required={_required}
      data={data}
      label={label}
      placeholder={placeholder}
      disabled={query.isLoading || props.disabled}
    />
  );
}
